module.exports = __webpack_public_path__ + "assets/main3D-e228a3eb6a5f424873c8012d564b2a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/main3D.jpg
// module id = 517
// module chunks = 1